module.exports = __webpack_public_path__ + "06d706562a2e0c4c33d49f1f1b019477.png";